<template>
  <div class="d-flex mt-2 sticky-box justify-center">
    <v-btn
      outlined
      tile
      large
      color="primary"
      class="non-text-transformation link mb-4"
      :loading="exportingExcel"
      @click="exportToExcel"
      data-cy="export-excel-button"
    >
      <v-icon left>mdi-microsoft-excel</v-icon>
      {{ $t('EXPORT_TO_EXCEL') }}
    </v-btn>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { GET_OFFER_ITEM } from '@/store/modules/offer/getters'
import { exportOfferToExcel } from '@/helpers/excelExport'

export default {
  name: 'ExportToExcelButton',
  data() {
    return {
      exportingExcel: false,
    }
  },
  computed: {
    ...mapGetters('offer', [GET_OFFER_ITEM]),
  },
  methods: {
    async exportToExcel() {
      this.exportingExcel = true
      try {
        const offer = this.$store.state.offer.offer
        const success = await exportOfferToExcel(offer, this.$t.bind(this))
        if (success) {
          this.$store.dispatch('alerts/createAlert', {
            id: 'exportExcelSuccess',
            type: 'success',
            contentKey: 'EXPORT_EXCEL_SUCCESS',
            autoHide: true,
          })
        } else {
          this.$store.dispatch('alerts/createAlert', {
            id: 'exportExcelError',
            type: 'error',
            contentKey: 'EXPORT_EXCEL_ERROR',
          })
        }
      } catch (error) {
        console.error('Error en exportación:', error)
        this.$store.dispatch('alerts/createAlert', {
          id: 'exportExcelError',
          type: 'error',
          content: this.$t('EXPORT_EXCEL_ERROR'),
        })
      } finally {
        this.exportingExcel = false
      }
    },
  },
}
</script>
